/**
 * BLOCK: modals
 */
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { animate } from "motion";

class Modals {
  constructor() {
    // elements
    this.$wrapper = $(".modal");
    this.$inner = this.$wrapper.find(".modal__inner");
    this.$backdrop = this.$wrapper.find(".modal__backdrop");
    this.$window = this.$wrapper.find(".modal__window");
    this.$close = this.$wrapper.find(".modal__window-close");
    this.$content = this.$wrapper.find(".modal__window-content");
    this.$title = this.$wrapper.find(".modal__window-title");

    // state
    this.isModalOpen = false;
    this.modalWindowHeight = 0;
    this.lastModalSlug = 0;
    this.data = window.modalData;

    // events
    $(document).on(
      "click",
      'a[href*="#modal-"]',
      this.#handleModalLinkClick.bind(this)
    );
    this.$close.on("click", this.closeModal.bind(this));
    this.$inner.on("click", this.#handleBackdropClick.bind(this));

    // init
    this.#checkIfIsHashTag();
  }

  #handleBackdropClick(event) {
    if (!this.isModalOpen) return;
    let rect = this.$window[0].getBoundingClientRect();
    if (
      rect.left > event.clientX ||
      rect.right < event.clientX ||
      rect.top > event.clientY ||
      rect.bottom < event.clientY
    ) {
      this.closeModal();
    }
  }

  /**
   * Wenn die URL einen Hashtag hat,
   * triggert er "openModal" mit der ModalSlug die er aus der Url hat.
   */
  #checkIfIsHashTag() {
    if (window.location.hash.indexOf("#modal-") !== -1) {
      const link = window.location.hash;
      const ModalSlug = link.substr(link.indexOf("#modal-") + 7, link.length);
      this.openModal(ModalSlug);
    }
  }

  /**
   * Wenn man auf einen Link clickt der ein auf grund seines Hashtags im href auf ein Modal verweist,
   * triggert er "openModal" mit der ModalSlug die er aus dem href hat.
   *
   * @param {Event} evt
   */
  #handleModalLinkClick(evt) {
    evt.preventDefault();
    const $target =
      evt.target.NodeName == "A" ? $(evt.target) : $(evt.target).closest("a");
    const link = $target.attr("href");
    const ModalSlug = link.substr(link.indexOf("#modal-") + 7, link.length);
    this.openModal(ModalSlug);
  }

  /**
   * Öffnet ein Modal
   *
   * @param {number} modalSlug
   */
  openModal(modalSlug) {
    this.#insertModalTemaplteById(modalSlug)
      .then((slug) => {
        this.#setModalOpen(slug);
        window.location.hash = `modal-${slug}`;
      })
      .catch((errMsg) => {
        console.error(errMsg);
      });
  }

  /**
   * Füllt das Modal Template mit dem passenden Modal Content zu der ModalSlug
   *
   * @param {Number} modalSlug
   * @returns {Promise}
   */
  #insertModalTemaplteById(modalSlug = false) {
    return new Promise((resolve, reject) => {
      // validate and change id to slug if needed
      if (!this.#isVailedmodalSlug(modalSlug)) {
        const possibleModalID = modalSlug;
        if (!this.#isVailedmodalId(possibleModalID)) {
          reject(
            `Fehler: Das Modal konnte nicht erstellt werden. Die ModalSlug "${modalSlug}" ist keine valide ModalSlug zu einem Modal`
          );
          return;
        } else {
          modalSlug = this.data.find((item) => item.id == modalSlug).slug;
        }
      }

      // Fall 2: Das Modal wird normal erstellt
      if (this.lastModalSlug !== modalSlug) {
        // Fall 2.A: Es ist schon ein Modal offen
        if (this.isModalOpen) {
          this.closeModal(modalSlug);

          // Fall 2.B: Es ist noch kein Modal offen: Das Modal wird erstellt und geöffent.
        } else {
          const data = this.data.find((item) => item.slug == modalSlug);
          const content = $.parseHTML(data.content);
          const title = $.parseHTML(data.title);
          this.$title.html(title);
          this.$content
            .html(content)
            .promise()
            .done(() => {
              window.luther.eventBus.emit("luther:pageContentChange");
              const $images = this.$content.find(".wp-block-image");
              if ($images.length) {
                $images.each((i, el) => {
                  const $el = $(el);
                  const $img = $el.find("img");
                  $img.on("load", () => {
                    $el.addClass("loaded");
                  });
                });
              }
            });
          resolve(modalSlug);
        }
        // Fall 3: Das Modal wurde schon erstellt und muss nur noch geöffenet werden
      } else {
        resolve(modalSlug);
      }
    });
  }

  /**
   * Öffnet ein Modal, dass bereits im Temaplte eingefügt wurde.
   * Nicht direkt aufrufen, sondern openModal nutzen.
   *
   * @param {Number} modalSlug
   */
  #setModalOpen(modalSlug) {
    this.isModalOpen = true;
    disableBodyScroll(this.$inner[0]);
    $("body > *:not(.modal):not(script):not(style):not(svg)").attr("inert", "");
    $("body > .modal").attr("inert", null);
    this.$wrapper.addClass("in");
    animate(this.$window[0], { y: [30, 0] }, { duration: 0.3 });
    this.lastModalSlug = modalSlug;
  }

  /**
   * Schließt ein Modal mit einer ModalSlug
   *
   * @param {Number} modalSlug
   */
  closeModal(modalSlug = false) {
    this.isModalOpen = false;
    enableBodyScroll(this.$inner[0]);
    $("body > *:not(.modal):not(script):not(style):not(svg)").attr(
      "inert",
      null
    );
    $("body > .modal").attr("inert", "");
    this.$wrapper.removeClass("in");
    animate(this.$window[0], { y: [0, 30] }, { duration: 0.3 });
    history.pushState(
      {},
      "",
      window.location.origin + window.location.pathname
    );
    if (modalSlug) {
      window.luther.eventBus.emit("luther:modalClosed", modalSlug);
      if (!this.#isVailedmodalSlug(modalSlug)) {
        return true;
      }
      setTimeout(() => {
        this.openModal(modalSlug);
      }, 200);
    }
  }

  /* ------------------
    Helper
  -------------------*/
  #isVailedmodalSlug(modalSlug = false) {
    if (!modalSlug) return;
    const modalData = this.data.find((item) => item.slug == modalSlug);
    return !!modalData;
  }

  #isVailedmodalId(modalId = false) {
    if (!modalId) return;
    const modalData = this.data.find((item) => item.id == modalId);
    return !!modalData;
  }

  _is_touch_device() {
    return "ontouchstart" in window;
  }
}

jQuery(document).ready(function ($) {
  window.$ = $;
  window.luther = window.luther || {};
  window.luther.modals = new Modals();
});
